import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedDataState {
  selectedArrayKey: string;
}

const initialState: SelectedDataState = {
  selectedArrayKey: '',
};

const mappedKeySlice = createSlice({
  name: 'mappedKey',
  initialState,
  reducers: {
    setMappedArrayKey(state, action: PayloadAction<string>) {
      state.selectedArrayKey = action.payload;
    },
  },
});

export const { setMappedArrayKey } = mappedKeySlice.actions;
export default mappedKeySlice.reducer;
